import { el } from 'redom';

import TextInputRow from 'generics/components/text-input-row';

import OptionsEditor from '../base';
import RequiredInputRow from '../required-input-row';
import OptionsInputControl from '../options-input-control';

class SelectFieldOptionsEditor extends OptionsEditor {

  constructor(configuration) {

    super(configuration);

    this.el = el('.text-field-options-editor-main', [
      this.renderPlaceholderInputRow(),
      this.renderOptionsInputSection(),
      this.renderRequiredAttributeInputRow()
    ]);

  }

  renderPlaceholderInputRow() {

    return new TextInputRow({
      label: 'Placeholder',
      placeholder: 'Placeholder text',
      value: this.fieldRow.options.placeholder,
      onChange: this.handlePlaceholderInputChange.bind(this)
    });

  }

  renderOptionsInputSection() {

    const selectOptions = this.fieldRow.options;

    const optionsInputControl = new OptionsInputControl({
      options: selectOptions.options,
      onChange: this.handleOptionsChange.bind(this)
    });

    return el('.form-input-row', [
      el('label.field-label', 'Options'),
      optionsInputControl
    ]);

  }

  renderRequiredAttributeInputRow() {

    return new RequiredInputRow({
      checked: this.fieldRow.options.required,
      onChange: this.handleRequiredAttributeChange.bind(this)
    });

  }

  handlePlaceholderInputChange(event, placeholder) {

    this.fieldRow.options.placeholder = placeholder;

    this.propogateFieldOptionsChange();

  }

  handleRequiredAttributeChange(required) {

    this.fieldRow.options.required = required;

    this.propogateFieldOptionsChange();

  }

  handleOptionsChange(options) {

    this.fieldRow.options.options = options;

    this.propogateFieldOptionsChange();

  }

}

export default SelectFieldOptionsEditor;